import GenericTableDto from 'modules/base/dto/table/GenericTableDto';
import GenericTableService from 'modules/base/service/GenericTableService';
import NamedDto from 'modules/base/dto/NamedDto';

class MeasurementTableService extends GenericTableService {
	constructor() {
		super();
		this.CONTROL = 'measurementTableControl';
	}

	/**
	 * @param {string} session
	 * @param {number} firstResult
	 * @param {number} maxResults
	 * @return {Promise<GenericTableDto<NamedDto>>}
	 */
	getList(session, firstResult, maxResults) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getList`, {
					session,
					firstResult,
					maxResults
				})
				.then(response => resolve(new GenericTableDto().setup(response.data, NamedDto)))
				.catch(reject);
		});
	}

	/**
	* @param {number} id
	* @param {Date} dateFrom
	* @param {Date} dateTo
	* @return {Promise<any>}
	*/
	getData(id, dateFrom, dateTo) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id,
					dateFrom,
					dateTo
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	* @param {string} name
	* @return {Promise<any>}
	*/
	getTimeseriesDetails(name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getTimeseriesDetails`, { name, })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new MeasurementTableService();
